import * as React from "react";
import type { PropsWithChildren } from "react";

import { Box, BoxProps, Heading, Text } from "@vinomofo/components";

export interface AccountSectionProps extends BoxProps {
  heading?: string;
  description?: string;
  cta?: React.ReactNode;
}

export const AccountSection = ({
  heading,
  description,
  cta,
  children,
  ...rest
}: PropsWithChildren<AccountSectionProps>): JSX.Element => {
  return (
    <Box>
      <Box mb={description || heading || cta ? [20, 30, 40] : 0} {...rest}>
        {heading && (
          <Heading as="h1" variant="sm">
            {heading}
          </Heading>
        )}

        {(description || cta) && (
          <Box
            display={["block", "flex"]}
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            mt={[10, 20, 20]}
          >
            {description && (
              <Text variant="sm">
                {description}
                {cta}
              </Text>
            )}
          </Box>
        )}
      </Box>
      {children}
    </Box>
  );
};
